import styled from 'styled-components';

export const AlertsListItemTitle = styled.div`
    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    align-items: center;
    color: #555555;
    padding: 0 0 0 12px;
    width: 80%;
    margin: 0;
    white-space: nowrap;
`;
